module.exports = __webpack_public_path__ + "img/03.e6d2caf5.png";